var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { title: "活动详情", visible: _vm.show, size: "50%" },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
            close: _vm.close,
          },
        },
        [
          _c("div", { staticClass: "padding-x-25" }, [
            _c("p", { staticClass: "title" }, [
              _c(
                "span",
                {
                  staticClass: "margin-left-10",
                  staticStyle: { "vertical-align": "middle" },
                },
                [_vm._v("基本信息")]
              ),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c(
                "span",
                {
                  staticClass:
                    "font-20 font-weight color-redFont margin-right-5",
                },
                [_vm._v("*")]
              ),
              _c("span", [_vm._v("活动名称：")]),
              _c("span", [_vm._v(_vm._s(_vm.detail.name || ""))]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c(
                "span",
                {
                  staticClass:
                    "font-20 font-weight color-redFont margin-right-5",
                },
                [_vm._v("*")]
              ),
              _c("span", [_vm._v("活动时间：")]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.detail.startTime || "") +
                    " 至 " +
                    _vm._s(_vm.detail.endTime || "")
                ),
              ]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c("span", [_vm._v("隶属公司：")]),
              _c("span", { staticClass: "f-1" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.detail.shiFouSuoYouXianLu === 1
                        ? "全部"
                        : _vm.detail.merchantNames
                    ) +
                    "\n        "
                ),
              ]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c("span", [_vm._v("可用线路：")]),
              _c("span", { staticClass: "f-1" }, [
                _vm._v(
                  _vm._s(
                    _vm.detail.shiFouSuoYouXianLu === 1
                      ? "全部"
                      : _vm.detail.lineNames
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c(
                "span",
                {
                  staticClass:
                    "font-20 font-weight color-redFont margin-right-5",
                },
                [_vm._v("*")]
              ),
              _c("span", [_vm._v("可参与订单数：")]),
              _c("span", [_vm._v(_vm._s(_vm.detail.huoDongCiShu || 0))]),
              _c("span", [
                _vm._v(
                  "，剩余：" + _vm._s(_vm.detail.shengYuHuoDongCiShu || 0)
                ),
              ]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c(
                "span",
                {
                  staticClass:
                    "font-20 font-weight color-redFont margin-right-5",
                },
                [_vm._v("*")]
              ),
              _c("span", [_vm._v("预算金额：")]),
              _c("span", [
                _vm._v(_vm._s(_vm.detail.huoDongZongJinEYuan || "0.00") + "元"),
              ]),
              _c("span", [
                _vm._v(
                  "，剩余" +
                    _vm._s(_vm.detail.shengYuhuoDongJinEYuan || "0.00") +
                    "元"
                ),
              ]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c("span", [_vm._v("使用条件：")]),
              _c("span", [
                _vm._v(_vm._s(_vm.detail.withNewUser ? "仅新用户可用" : "-")),
              ]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c("span", [_vm._v("是否可重复参与：")]),
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.detail.shiFouChongFu ? "可重复参与" : "不可重复参与"
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c("span", [_vm._v("与优惠券互斥：")]),
              _c("span", [
                _vm._v(_vm._s(_vm.detail.withCoupon ? "互斥" : "不互斥")),
              ]),
            ]),
            _c("div", { staticClass: "flex-top font-14 margin-bottom-20" }, [
              _c("span", { staticStyle: { "line-height": "26px" } }, [
                _vm._v("使用说明："),
              ]),
              _c("div", {
                staticStyle: {
                  "white-space": "pre-line",
                  "line-height": "26px",
                },
                domProps: { innerHTML: _vm._s(_vm.detail.describe) },
              }),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c("span", { staticStyle: { "line-height": "26px" } }, [
                _vm._v("扫码补票是否可用："),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.detail.buPiaoShiFouKeYong === 1 ? "是" : "否")
                ),
              ]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c("span", { staticStyle: { "line-height": "26px" } }, [
                _vm._v("是否关联渠道码："),
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.detail.enableChannelCode === 1 ? "是" : "否")
                ),
              ]),
            ]),
            _vm.detail.enableChannelCode === 1
              ? _c(
                  "div",
                  { staticClass: "flex-start font-14 margin-bottom-20" },
                  [
                    _c("span", { staticStyle: { "line-height": "26px" } }, [
                      _vm._v("关联渠道码："),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.channelIdList))]),
                  ]
                )
              : _vm._e(),
            _vm.detail.enableChannelCode === 1
              ? _c(
                  "div",
                  { staticClass: "flex-start font-14 margin-bottom-20" },
                  [
                    _c("span", { staticStyle: { "line-height": "26px" } }, [
                      _vm._v("活动规则："),
                    ]),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.detail.activityRule) },
                    }),
                  ]
                )
              : _vm._e(),
            _c("p", { staticClass: "title" }, [
              _c(
                "span",
                {
                  staticClass: "margin-left-10",
                  staticStyle: { "vertical-align": "middle" },
                },
                [_vm._v("优惠条件")]
              ),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-10" }, [
              _c("div", [
                _c(
                  "span",
                  {
                    staticClass:
                      "font-20 font-weight color-redFont margin-right-5",
                  },
                  [_vm._v("*")]
                ),
                _c("span", [_vm._v("优惠条件：")]),
              ]),
              _vm.detail.tiaoJian === 1
                ? _c("div", [
                    _c(
                      "span",
                      { staticClass: "margin-left-5 margin-right-10" },
                      [_vm._v("金额")]
                    ),
                    _c("span", [_vm._v("满**元可用")]),
                  ])
                : _vm._e(),
              _vm.detail.tiaoJian === 2
                ? _c("div", [
                    _c(
                      "span",
                      { staticClass: "margin-left-5 margin-right-10" },
                      [_vm._v("人数")]
                    ),
                    _c("span", [_vm._v("满**人可用")]),
                  ])
                : _vm._e(),
            ]),
            _vm.detail.activityLiJianItemVoList &&
            _vm.detail.activityLiJianItemVoList.length > 0
              ? _c(
                  "div",
                  { staticClass: "padding-left-20 font-14" },
                  _vm._l(
                    _vm.detail.activityLiJianItemVoList,
                    function (item, index) {
                      return _c(
                        "div",
                        {
                          key: item.activityLiJianId,
                          staticClass: "flex-start margin-bottom-10",
                        },
                        [
                          _vm.detail.tiaoJian === 1
                            ? _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n            层级" +
                                      _vm._s(index + 1) +
                                      "：\n            "
                                  ),
                                  _vm.detail.youHuiNeiRong === 1
                                    ? [
                                        _vm._v(
                                          "\n              满" +
                                            _vm._s(item.topMoney) +
                                            "元，减" +
                                            _vm._s(item.liJianMoney) +
                                            "元\n            "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.detail.youHuiNeiRong === 2
                                    ? [
                                        _vm._v(
                                          "\n              满" +
                                            _vm._s(item.topMoney) +
                                            "元，打" +
                                            _vm._s(item.zheKou) +
                                            "折，最高优惠" +
                                            _vm._s(item.maxYouHuiMoney) +
                                            "元\n            "
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm.detail.tiaoJian === 2
                            ? _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n            层级" +
                                      _vm._s(index + 1) +
                                      "：\n            "
                                  ),
                                  _vm.detail.youHuiNeiRong === 1
                                    ? [
                                        _vm._v(
                                          "\n              满" +
                                            _vm._s(item.topPeople) +
                                            "人，减" +
                                            _vm._s(item.liJianMoney) +
                                            "元\n            "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.detail.youHuiNeiRong === 2
                                    ? [
                                        _vm._v(
                                          "\n              满" +
                                            _vm._s(item.topPeople) +
                                            "人，打" +
                                            _vm._s(item.zheKou) +
                                            "折，最高优惠" +
                                            _vm._s(item.maxYouHuiMoney) +
                                            "元\n            "
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      )
                    }
                  ),
                  0
                )
              : _vm._e(),
            _c("p", { staticClass: "title" }, [
              _c(
                "span",
                {
                  staticClass: "margin-left-10",
                  staticStyle: { "vertical-align": "middle" },
                },
                [_vm._v("其他")]
              ),
            ]),
            _c("div", { staticClass: "flex-between flex-1 padding-right-30" }, [
              _c(
                "div",
                { staticClass: "flex-start font-14 margin-bottom-20" },
                [
                  _c("span", [_vm._v("创建人：")]),
                  _c("span", [_vm._v(_vm._s(_vm.detail.createUserName || ""))]),
                ]
              ),
              _c(
                "div",
                { staticClass: "flex-start font-14 margin-bottom-20" },
                [
                  _c("span", [_vm._v("创建时间：")]),
                  _c("span", [_vm._v(_vm._s(_vm.detail.createTime || ""))]),
                ]
              ),
            ]),
            _c("div", { staticClass: "flex-between flex-1 padding-right-30" }, [
              _c(
                "div",
                { staticClass: "flex-start font-14 margin-bottom-20" },
                [
                  _c("span", [_vm._v("审核人：")]),
                  _c("span", [_vm._v(_vm._s(_vm.detail.shenHeUserName || ""))]),
                ]
              ),
              _c(
                "div",
                { staticClass: "flex-start font-14 margin-bottom-20" },
                [
                  _c("span", [_vm._v("审核时间：")]),
                  _c("span", [_vm._v(_vm._s(_vm.detail.shenHeTime || ""))]),
                ]
              ),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c("span", [_vm._v("活动状态：")]),
              _c("span", [_vm._v(_vm._s(_vm.detail.stateStr || ""))]),
            ]),
            _c("div", { staticClass: "flex-start font-14 margin-bottom-20" }, [
              _c("span", [_vm._v("不通过原因：")]),
              _c("span", [_vm._v(_vm._s(_vm.detail.shenHeRemark || "-"))]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }